import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.partnerTransactions
)

export const selectPartnerTransactions = createSelector(
    baseSelector,
    (state) => state.transactions
)

export const selectPartnerTransactionsLoading = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)

export const selectPartnerTransactionsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)

export const selectPartnerTransactionsError = createSelector(
    baseSelector,
    (state) => state.error
)

export const selectCurrentPartner = createSelector(
    baseSelector,
    (state) => state.partnerId
)

export const selectCurrentStore = createSelector(
    baseSelector,
    (state) => state.storeId
)


export const selectCurrentSearch = createSelector(
    baseSelector,
    (state) => state.search
)

export const selectCurrentClientType = createSelector(
    baseSelector,
    (state) => state.clientType
)

export const selectCurrentPage = createSelector(
    baseSelector,
    (state) => state.page
)

export const selectTotalPages = createSelector(
    baseSelector,
    (state) => state.totalPages
)
export const selectStartDate = createSelector(
    baseSelector,
    (state) => state.startDate
)
export const selectEndDate = createSelector(
    baseSelector,
    (state) => state.endDate
)